
// import SparkMD5 from 'spark-md5'
import sparkMd5 from 'spark-md5';
// 获取文件的唯一MD5标识码
// export function getFileMd5(file) {
//   return new Promise((resolve, reject) => {
//     const fileReader = new FileReader()
//     const spark = new SparkMD5.ArrayBuffer()
//     fileReader.readAsArrayBuffer(file)
//     fileReader.onload = e => {
//       spark.append(e.target.result)
//       let md5 = spark.end()
//       resolve(md5)
//     }
//   })
// }
export function calculateFileMD5(file) {
  return new Promise(resolve => {
    const chunk_size = 5 * 1024 * 1024; // 2MB
    const chunks = Math.ceil(file.size / chunk_size);
    const file_reader = new FileReader();
    let current_chunk = 0;
    const spark = new sparkMd5.ArrayBuffer();
    file_reader.onload = e => {
      spark.append(e.target.result);
      current_chunk++;

      if (current_chunk < chunks) {
        loadNext();
      } else {
        resolve(spark.end());
      }
    };

    function loadNext() {
      const start = current_chunk * chunk_size;
      const end = Math.min(file.size, start + chunk_size);

      file_reader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNext();
  });
}
